import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Layout from "../layouts/LayoutDefault.jsx";
import RandomImageBackground from "../components/RandomImageBackgroudn";
import GoogleLogInBtn from "../components/utils/GoogleLogInBtn.jsx";

const Register = (props) => {
  const apiUrl = import.meta.env.VITE_API_URL;
  const apiRoute = "register_user";
  const apiEndpoint = `${apiUrl}${apiRoute}`;

  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rePassword, setRePassword] = useState("");
  const [terms, setTerms] = useState(false);
  const [newsLetter, setNewsLetter] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleRePasswordChange = (e) => {
    setRePassword(e.target.value);
  };

  const handleTermsChange = (e) => {
    setTerms(e.target.value);
  };

  const handleNewsChange = (e) => {
    setNewsLetter(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!email) {
      return setErrorMsg("Fyll i epost");
    }
    if (!password) {
      return setErrorMsg("Fyll i lösenord");
    }
    if (!rePassword) {
      return setErrorMsg("Fyll i lösenord igen");
    }
    if (password !== rePassword) {
      return setErrorMsg("Lösenorden matchar inte");
    }
    if (terms == false) {
      return setErrorMsg("Du måste acceptera villkoren");
    }

    setIsLoading(true);
    // Make a POST request here
    axios
      .post(
        apiEndpoint,
        new URLSearchParams({
          email: email,
          password: password,
          news_letter: newsLetter,
        }),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        },
      )
      .then((response) => {
        const data = response.data;
        // Handle the response data
        if (data) {
          setSuccessMsg(
            "Ett mail skickas inom kort. Där du kan bekräfta din epost",
          );
          setErrorMsg("");
        } else {
          setErrorMsg(response.error.data.message);
        }
      })
      .catch((error) => {
        // Handle the error
        console.log(
          "Error during registration:",
          error.response ? error.response.data : error.message,
        );
        if (error.response.data.message) {
          setErrorMsg(error.response.data.message);
        } else {
          setErrorMsg("Något blev fel, pröva ladda om sidan och testa igen");
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <Layout
      title="Registera dig på Lokult"
      description="Registera dig hos oss helt gratis. Sen kan du lägga till ditt eller dina egna musikprojek. Välkommen till Lokult"
    >
      <div className="hero min-h-screen">
        <RandomImageBackground opacity={0.7} />
        <div className="hero-content flex-col lg:flex-row-reverse shadow-2xl bg-[#131313]/90 backdrop-blur-md rounded-2xl border border-white/10 p-6 sm:p-10 gap-10 max-w-5xl">
          <div className="text-center lg:text-left max-w-md">
            <span className="text-[#0047ff] text-[10px] font-black tracking-[0.25em] uppercase block mb-3">
              GÅ MED I LOKULT
            </span>
            <h1 className="text-4xl sm:text-5xl font-black text-white uppercase tracking-wider leading-none mb-6">
              Välkommen
            </h1>
            <h2 className="text-lg font-extrabold text-stone-200 uppercase tracking-wide mb-4">
              Vad kul att du vill skapa ett konto!
            </h2>
            <p className="text-sm text-stone-400 leading-relaxed mb-6">
              När du väl har skapat ditt konto kan du lägga till alla dina band
              och musikprojekt. Vi ser fram emot att få höra vad du har skapat
              och vi är tacksamma för att du väljer vara med oss på Lokult.
            </p>
            <div className="text-xs text-amber-500 font-medium bg-amber-500/10 border border-amber-500/20 rounded-2xl p-5 leading-relaxed">
              <span className="font-bold uppercase tracking-wider block mb-1">
                Lokult är i beta-stadie nu
              </span>
              Det betyder att det kan vara lite buggigt och att sidan kan
              förändras mycket på kort tid eller stundtals ligga nere. Tack för
              ditt tålamod!
            </div>
          </div>
          <div className="card shrink-0 w-full max-w-sm bg-black/40 border border-white/10 rounded-2xl shadow-xl">
            <form className="card-body p-6 sm:p-8 space-y-4">
              <h1 className="text-2xl font-black text-white uppercase tracking-wider">
                Skapa konto
              </h1>
              <div className="divider text-[9px] text-stone-500 font-bold uppercase tracking-widest">
                Registrera med
              </div>
              <div className="pt-1">
                <GoogleLogInBtn
                  register={true}
                  newsLetter={newsLetter}
                  setErrorMsg={setErrorMsg}
                />
              </div>
              <div className="divider text-[9px] text-stone-500 font-bold uppercase tracking-widest">
                Eller fyll i manuellt
              </div>
              <div className="form-control">
                <label className="label">
                  <span className="text-[10px] font-bold text-stone-400 uppercase tracking-wider">
                    Epost
                  </span>
                </label>
                <input
                  type="email"
                  onChange={handleEmailChange}
                  autoComplete="email"
                  placeholder="din.epost@domän.se"
                  className="input input-bordered bg-[#181818] border-white/10 focus:border-[#0047ff] text-stone-200 rounded-xl w-full"
                  required
                />
              </div>
              <div className="form-control">
                <label className="label">
                  <span className="text-[10px] font-bold text-stone-400 uppercase tracking-wider">
                    Lösenord
                  </span>
                </label>
                <input
                  type="password"
                  onChange={handlePasswordChange}
                  autoComplete="new-password"
                  placeholder="••••••••"
                  className="input input-bordered bg-[#181818] border-white/10 focus:border-[#0047ff] text-stone-200 rounded-xl w-full"
                  required
                />
              </div>
              <div className="form-control">
                <label className="label">
                  <span className="text-[10px] font-bold text-stone-400 uppercase tracking-wider">
                    Bekräfta lösenord
                  </span>
                </label>
                <input
                  type="password"
                  onChange={handleRePasswordChange}
                  autoComplete="new-password"
                  placeholder="••••••••"
                  className="input input-bordered bg-[#181818] border-white/10 focus:border-[#0047ff] text-stone-200 rounded-xl w-full"
                  required
                />
              </div>
              <div className="form-control mt-2">
                <label className="cursor-pointer label flex items-center justify-between">
                  <span className="text-xs text-stone-400">
                    Jag godkänner{" "}
                    <a href="/rules" className="text-[#0047ff] hover:underline font-bold">
                      villkoren & reglerna
                    </a>
                  </span>
                  <input
                    type="checkbox"
                    onChange={handleTermsChange}
                    className="checkbox border-white/20 checked:bg-[#0047ff] checked:border-[#0047ff] rounded"
                    required
                  />
                </label>
              </div>
              <div className="form-control">
                <label className="cursor-pointer label flex items-center justify-between">
                  <span className="text-xs text-stone-400">
                    Nyhetsbrev (max ett per månad)
                  </span>
                  <input
                    type="checkbox"
                    onChange={handleNewsChange}
                    className="checkbox border-white/20 checked:bg-[#0047ff] checked:border-[#0047ff] rounded"
                  />
                </label>
              </div>

              <div className="form-control mt-6">
                {successMsg ? (
                  <p className="text-success font-bold text-center text-sm">
                    {successMsg}
                  </p>
                ) : (
                  <button
                    className="btn bg-[#0047ff] hover:bg-blue-700 text-white border-none rounded-full w-full font-bold uppercase tracking-wider text-xs shadow-[0_4px_15px_rgba(0,71,255,0.3)] transition-transform duration-300 hover:scale-[1.02]"
                    onClick={handleSubmit}
                  >
                    {isLoading ? "Laddar..." : "Registrera"}
                  </button>
                )}
              </div>
              {errorMsg && (
                <h4 className="text-error font-semibold text-xs text-center">{errorMsg}</h4>
              )}
            </form>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Register;
